import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RouteProvider } from '../../providers/route/route';
import { RegisterProvider } from '../../providers/register/register';
import { DeeplinkProvider } from '../../providers/marketing/deeplink';
import { APP_CONFIG } from '../../environment';
import { FeatureFlagTypes, UtilsProvider } from '../../providers/myria/utils-provider';
import { COUNTRY_SETTINGS } from '../../providers/myria/app-variables';
import { Branding } from '../../environment/branding';

@Component({
  selector: 'rmt-referralcode-label',
  templateUrl: 'rmt-referralcode-label.html'
})
export class RmtReferralcodeLabelComponent {

  referralCode: string = "";
  effectText: string = "";
  referAFriendAvailable: boolean = false;
  @Input() showDeleteButton: boolean = false;
  constructor(private translate: TranslateService,private routeProvider: RouteProvider,
    private registerProvider: RegisterProvider, private deeplinkProvider: DeeplinkProvider, private utilsProvider: UtilsProvider) {
  }

  async ngAfterViewInit(){
    this.referralCode = this.deeplinkProvider.getDeeplinkPromoCode(APP_CONFIG.region.defaultCountryFrom);
    this.referralCode = (this.referralCode === undefined || this.referralCode === null) ? "" : this.referralCode;
  this.referAFriendAvailable = await UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.ShowReferAFriendCTA);
  }

  onHaveReferralCodeClick(){
    this.routeProvider.openActionSheet(this.routeProvider.pages.ReferralRedeemPage,{}, (data) => {
      if(data !== null && data !== undefined){
        this.referralCode = data.referralCode;
        this.effectText = data.effectText;
        this.saveReferralCode(this.referralCode);
      }
    }, 'rmt-select-actionsheet-modal');
  }

  openPromotionInfo() {
    const params = {
      header: this.translate.instant('form.registrationForm.referralCode.infoModalHeader'),
      texts: [
        this.translate.instant('form.registrationForm.referralCode.infoRaFModalBody'),
      ],
      primaryButton: this.translate.instant('page.signInForgotPage.gotItButton'),
      isTextCenter: true
    }
    this.routeProvider.openActionSheet(this.routeProvider.pages.ActionsheetInfoPage, params, () => {}, 'rmt-actionsheet-info-modal', false); 
    setTimeout(() => {
      if(document.getElementsByClassName("actionsheet_content") && document.getElementsByClassName("actionsheet_content")[0]){
        (<HTMLElement>document.getElementsByClassName("actionsheet_content")[0]).style.paddingBottom = "0px"
      }
      if(document.getElementsByClassName("actionsheet_text") && document.getElementsByClassName("actionsheet_text")[0]){
        (<HTMLElement>document.getElementsByClassName("actionsheet_text")[0]).style.paddingBottom = "12px"
      }
    }, 50);
  }

  onDeleteReferralClick(){
    this.referralCode = ""; 
    this.saveReferralCode(this.referralCode);
  }

  saveReferralCode(promo){
    let register: any = this.registerProvider.getCurrentRegistration();
    register.ReferralCode = promo;
    this.registerProvider.setCurrentRegistration(register);
  }

}



// WEBPACK FOOTER //
// ./src/components/rmt-referralcode-label/rmt-referralcode-label.ts